import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule, TabsModule } from 'ngx-bootstrap';

import { SchedulesOnProfileComponent } from './schedules-on-profile.component';
import { SchedulesOnProfileActionsModalComponent } from './schedules-on-profile-actions-modal/schedules-on-profile-actions-modal.component';
import { FeedbackExecutionComponentModule } from '../feedback-execution/feedback-execution-component.module';
import { ScheduleJobMatchItemModule } from '../job-match-actions/schedule-job-match-item/schedule-job-match-item.module';
import { CancelJobMatchMeetingModule } from '../job-match-actions/cancel-job-match-meeting/cancel-job-match-meeting.module';
import { MoveJobMatchStepModule } from '../job-match-actions/move-job-match-step/move-job-match-step.module';

@NgModule({
    declarations: [
        SchedulesOnProfileComponent,
        SchedulesOnProfileActionsModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        FeedbackExecutionComponentModule,
        ScheduleJobMatchItemModule,
        CancelJobMatchMeetingModule,
        MoveJobMatchStepModule,
        ModalModule.forRoot(),
        TabsModule.forRoot()
    ],
    exports: [
        SchedulesOnProfileComponent,
        SchedulesOnProfileActionsModalComponent
    ],
    entryComponents: [
        SchedulesOnProfileComponent,
        SchedulesOnProfileActionsModalComponent
    ]
})
export class SchedulesOnProfileModule { }
